import { IPlan, IPriceStructure } from ".";

export const team: IPlan = {
  id: "team",
  name: "Team",
  description: "Scale collaboration with unlimited members and shared publishing workflows.",
  chargebee: new Set([
    "team-monthly-aud",
    "team-monthly-usd",
    "team-monthly-eur",
    "team-monthly-gbp",
    "team-annual-aud",
    "team-annual-usd",
    "team-annual-eur",
    "team-annual-gbp",
  ]),
  features: {
    "organisation-manage-publish-configurations": true,
    "organisation-team-leader-view": true,
    "organisation-team-limit": 1,
    "organisation-member-limit": 200,
    "organisation-team-member-limit": 200,
    "organisation-sites": true,
    "page-settings-amp-enabled": false,
    "page-settings-analytics-ga": true,
    "page-settings-override-social-cover-url": true,
    "shorthand-analytics-tracking": true,
    "story-credits-required": false,
    "themes-demo": false,
    "publish-embed-ui": true,
    "story-comments": true,
    "theme-builder": true,
    "page-settings-password-protect-previews": true,
    "custom-hosting-limit": 1,
    "publish-configurations-download": true,
    "story-text-translation": true,
    "foreground-animation": true,
    charts: true,
  },
  marketing: {
    label: "Brand control and customization options for professional teams.",
    className: "plan-team",
    benefits: [
      "Downloadable story archives",
      "Password-protected previews",
      "Google Analytics",
      "Story analytics exports",
      "Basic theme builder",
      "Email support",
    ],
    storyInclusions: 12,
    seatInclusions: "Unlimited",
    prices: {
      planPrice: {
        monthly: { USD: 875 },
        yearly: { USD: 700 },
        nfp: { USD: 525 },
      },
      publishAddonPrice: {
        monthly: { USD: 300 },
        yearly: { USD: 300 },
        nfp: { USD: 180 },
      },
    } as IPriceStructure,
  },
};
